
import { api_dds_experiment } from "@/services/dds/api_dds_experiment";
const apiService = new api_dds_experiment(process.env.VUE_APP_BASE_URL);
import { api_dds_general } from "@/services/dds/api_dds_general";
const apiDDSGeneral = new api_dds_general(process.env.VUE_APP_BASE_URL);
export default {
  data: () => ({
    camera_dialog: false,
    camera_dialog_camera: {},
    setup_dialog: false,
  }),
  methods: {
    popCamera(camera) {
      this.camera_dialog = true;
      this.camera_dialog_camera = camera;
    },
    popSetup() {
      this.setup_dialog = true;
    },
    getSolutionConfig(){
      var self = this;
      apiService
       .getSolutionConfig(
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            if(response.source == "custom"){
              self.label.sol1["eng"] = response.sol1.eng;
              self.label.sol1["chi"] = response.sol1.eng;
              self.label.sol2["eng"] = response.sol2.eng;
              self.label.sol2["chi"] = response.sol2.eng;
              self.label.sol3["eng"] = response.sol3.eng;
              self.label.sol3["chi"] = response.sol3.eng;
            }
            else if (response.source=="default"){
              self.label.sol1["eng"] = response.sol1.eng;
              self.label.sol1["chi"] = response.sol1.chi;
              self.label.sol2["eng"] = response.sol2.eng;
              self.label.sol2["chi"] = response.sol2.chi;
              self.label.sol3["eng"] = response.sol3.eng;
              self.label.sol3["chi"] = response.sol3.chi;
            }
          }
          else {
            console.log("fail no action");
            // no action;
          }
        });
    },    
    setExperimentOverrideOn(callback) {
      var self = this;
      apiService
        .setExperimentOverrideOn(
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
        )
        .then((response) => {
          self.checkOverrided();
        });
    },
    setExperimentOverrideOff(callback) {
      var self = this;
      apiService
        .setExperimentOverrideOff(
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
        )
        .then((response) => {
          self.checkOverrided();
        });
    },
    getSetupPhoto(){
      var self = this;
      apiService
        .getSetupPhoto(
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            self.setup_photos = response.photos;
          }
        });
    },
    getLabManual(){
      var self = this;
      apiService
        .getLabManual(
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            //window.open(response.filename);
            self.lab_manual.school_chi = response.school_chi;
            self.lab_manual.school_en = response.school_en;
            self.lab_manual.suggested_chi = response.suggested_chi;
            self.lab_manual.suggested_en = response.suggested_en;
            console.log(self.lab_manual.school_chi,self.lab_manual.school_en,self.lab_manual.suggested_chi,self.lab_manual.suggested_en );
          }
        });
    },
    getExperimentVideoDemo(){
      var self = this;
      apiService
        .getExperimentVideoDemo(
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            //window.open(response.filename);
            self.video_demo.school_chi = response.school_chi;
            self.video_demo.school_en = response.school_en;
            self.video_demo.suggested_chi = response.suggested_chi;
            self.video_demo.suggested_en = response.suggested_en;
            console.log(self.video_demo.school_chi,self.video_demo.school_en,self.video_demo.suggested_chi,self.video_demo.suggested_en );
          }
        });
    },
    checkBookingEnd() {
      var self = this;
      apiService
        .checkBookingEnd(
          self.$cookies.get('booking_id'),
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            if(response.exceed){
              alert("This Booking is end. You are forced leaving from this experiment page.");
              clearInterval(self.inte);
              self.$cookies.remove('booking_id');
              
              self.$router.push(
                "/booking/" + self.school_code
              );
            }
            else if(!response.exceed){
            }
          }
          else {
            alert("Error in retrieving data. Please re-enter experiment via Booking Page.");
              clearInterval(self.inte);              
              self.$router.push(
                "/booking/" + self.school_code
              );
          }
        });
    },
    getValue(device_id, callback, is_group_experiment = false) {
      var self = this;
      apiService
        .getValue(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          is_group_experiment,
        )
        .then((response) => {
          if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.error);
          }
          else{
            self.api.value_got_at = response.value_got_at;
            self.api.value_set_at = response.value_set_at;
            self.api.command_got_at = response.command_got_at;
            self.api.command_set_at = response.command_set_at;
            if (response.value != '') {
              self.api.value = JSON.parse(response.value);
            }
            if (callback) {
              callback();
            }
          }
        });
    },
    getGroupValue(device_id, session_type, callback) {
      var self = this;
      apiService
        .getGroupValue(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          session_type
        )
        .then((response) => {
          if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.error);
          }
          else{
            self.api.value_got_at = response.value_got_at;
            self.api.value_set_at = response.value_set_at;
            self.api.command_got_at = response.command_got_at;
            self.api.command_set_at = response.command_set_at;
            if (response.value != '') {
              self.api.value = JSON.parse(response.value);
            }
            if (callback) {
              callback();
            }
          }
        });
    },
    getChart(device_id) {
      var self = this;
      apiService
        .getChart(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
        )
        .then((response) => {
          self.api.chart = response;
          self.series = [{ data: response }];
          self.loading = false;
        });
    },    
    getChartMultiple(device_id, no_of_data, data1, data2='') {
      var self = this;
      apiService
        .getChartMultiple(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          no_of_data,
          data1,
          data2
        )
        .then((response) => {
          self.api.chart = response;
          self.data_1.data_max = response.data_1_max;
          self.data_1.data_min = response.data_1_min;
          self.data_2.data_max = response.data_2_max;
          self.data_2.data_min = response.data_2_min;
          if(self.$store.state.current.experiment.toUpperCase()=='GREENHOUSE'){
            self.series = [ {name: 'Temperature 1', data: response.data_1 }, { name: 'Temperature 2', data: response.data_2 } ];            
            setTimeout(function(){
              self.$refs.realtimeChart.updateSeries(self.series, false);
              self.loading = false;
            },500)
          }
          else if(no_of_data==1){            
            self.series = [{ data: response.data_1 }];
            self.options.yaxis = {
              title: {
                text: self.graph_names[data1]+"("+ self.graph_units[data1] +")"
              },
            };
            if(self.manual_yaxis){
              self.options.yaxis.max=parseFloat(self.data_1.max);
              self.options.yaxis.min=parseFloat(self.data_1.min);
              if(self.options.yaxis.max==NaN) self.options.yaxis.max=undefined;
              if(self.options.yaxis.min==NaN) self.options.yaxis.min=undefined;
            }
            setTimeout(function(){
              if(response.data_1==null) {
                self.series = [ { data: [] } ];
              }
              self.$refs.realtimeChart.updateSeries(self.series, false);
              self.$refs.realtimeChart.updateOptions(self.options);
              self.loading = false;
            },500)
          }
          else if(no_of_data==2){
            self.options.yaxis= [
              {
                max: response.data_1_max,
                min: response.data_1_min,
                title: {
                  text: self.graph_names[data1]+"("+ self.graph_units[data1] +")",
                  style: {
                    color: '#FF0000',
                  }
                },
              },
              {
                max: response.data_2_max,
                min: response.data_2_min,
                opposite: true,
                title: {
                  text: self.graph_names[data2]+"("+ self.graph_units[data2] +")",
                  style: {
                    color: '#0000FF',
                  }
                },
              },
            ];
            self.series= [
              { name: self.graph_names[data1], data: [],},
              { name: self.graph_names[data2], data: [],}
            ];
            if(self.manual_yaxis){
              if(isNaN(self.data_1.max)) ;
              else self.options.yaxis[0].max = parseFloat(self.data_1.max);
              
              if(isNaN(self.data_1.min)) ;
              else self.options.yaxis[0].min = parseFloat(self.data_1.min);

              if(isNaN(self.data_2.max)) ;
              else self.options.yaxis[1].max = parseFloat(self.data_2.max);
              
              if(isNaN(self.data_2.min)) ;
              else self.options.yaxis[1].min = parseFloat(self.data_2.min);
              
            }
            setTimeout(function(){
              
              if(response.data_1 == null) 
                self.series[0].data = [];
              else 
                self.series[0].data = response.data_1;

              if(response.data_2 == null || response.data_2==undefined)
                self.series[1].data = [];
              else
                self.series[1].data = response.data_2;

              self.$refs.realtimeChart.updateSeries(self.series, false);
              self.$refs.realtimeChart.updateOptions(self.options);
              self.loading = false;
            },500)
          }          
        });
    },
    clearChartMultiple(device_id, no_of_data, data, callback) {
      var self = this;
      apiService
        .clearChartMultiple(
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          no_of_data,
          data
        )
        .then((response) => {
            self.getChartMultiple(device_id, self.selected_graph.length, self.selected_graph[0], self.selected_graph[1]);
        });
    },
    applyManualYAxis(type, nod=1){
      var self = this;
      if(type=="multiple"){
        if(nod==1){
          if(self.manual_yaxis){
            if(isNaN(self.data_1.max_input) || isNaN(self.data_1.min_input)) {
              self.data_1.manual_max = undefined;
              self.data_1.manual_min = undefined;
              self.options.yaxis = {
                min: undefined,
                max: undefined,
                title: {
                  text: self.graph_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }
              }
              self.options_chi.yaxis = {
                min: undefined,
                max: undefined,
                title: {
                  text: self.graph_chi_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }                
              }
            }
            else {
              self.data_1.manual_max = self.data_1.max_input;
              self.data_1.manual_min = self.data_1.min_input;
              self.options.yaxis = {
                min: parseFloat(self.data_1.manual_min),
                max: parseFloat(self.data_1.manual_max),
                title: {
                  text: self.graph_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }
              }
              self.options_chi.yaxis = {
                min: parseFloat(self.data_1.manual_min),
                max: parseFloat(self.data_1.manual_max),
                title: {
                  text: self.graph_chi_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
                }
              }
            }
          }
          else if(!self.manual_yaxis){
            self.data_1.manual_max = undefined;
            self.data_1.manual_min = undefined;
            self.data_2.manual_max = undefined;
            self.data_2.manual_min = undefined;
            self.options.yaxis = {
              min: undefined,
              max: undefined,
              title: {
                text: self.graph_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
              }
            }
            self.options_chi.yaxis = {
              min: undefined,
              max: undefined,
              title: {
                text: self.graph_chi_names[self.selected_graph[0]]+" ("+ self.graph_units[self.selected_graph[0]] +")"
              }
            }
          }
          setTimeout(function(){            
            if(self.$i18n.locale == 'tc'){
              self.$refs.realtimeChart.updateOptions(self.options_chi);
            }
            else {
              self.$refs.realtimeChart.updateOptions(self.options);
            }
            self.loading = false;
          },500)
        }
        else if(nod==2){
          if(self.manual_yaxis){
            if(isNaN(self.data_1.max_input) || isNaN(self.data_1.min_input)) {
              self.data_1.manual_max = undefined;
              self.data_1.manual_min = undefined;

              self.options.yaxis[0].max = parseFloat(self.data_1.data_max);
              self.options_chi.yaxis[0].max = parseFloat(self.data_1.data_max);
              self.options.yaxis[0].min = parseFloat(self.data_1.data_min);
              self.options_chi.yaxis[0].min = parseFloat(self.data_1.data_min);
            }
            else {              
              self.data_1.manual_max = self.data_1.max_input;
              self.data_1.manual_min = self.data_1.min_input;

              self.options.yaxis[0].max = parseFloat(self.data_1.manual_max);
              self.options_chi.yaxis[0].max = parseFloat(self.data_1.manual_max);
              self.options.yaxis[0].min = parseFloat(self.data_1.manual_min);
              self.options_chi.yaxis[0].min = parseFloat(self.data_1.manual_min);
            }
            if(isNaN(self.data_2.max_input) || isNaN(self.data_2.min_input)) {
              self.data_2.manual_max = undefined;
              self.data_2.manual_min = undefined;

              self.options.yaxis[1].max = parseFloat(self.data_2.data_max);
              self.options_chi.yaxis[1].max = parseFloat(self.data_2.data_max);
              self.options.yaxis[1].min = parseFloat(self.data_2.data_min);
              self.options_chi.yaxis[1].min = parseFloat(self.data_2.data_min);
            }
            else {
              self.data_2.manual_max = self.data_2.max_input;
              self.data_2.manual_min = self.data_2.min_input;

              self.options.yaxis[1].max = parseFloat(self.data_2.manual_max);
              self.options_chi.yaxis[1].max = parseFloat(self.data_2.manual_max);
              self.options.yaxis[1].min = parseFloat(self.data_2.manual_min);
              self.options_chi.yaxis[1].min = parseFloat(self.data_2.manual_min);
            }
          }
          else if(!self.manual_yaxis){
            self.data_1.manual_max = undefined;
            self.data_1.manual_min = undefined;
            self.data_2.manual_max = undefined;
            self.data_2.manual_min = undefined;

            self.options.yaxis[0].max = parseFloat(self.data_1.data_max);
            self.options.yaxis[0].min = parseFloat(self.data_1.data_min);
            self.options.yaxis[1].max = parseFloat(self.data_2.data_max);
            self.options.yaxis[1].min = parseFloat(self.data_2.data_min);
            
            self.options_chi.yaxis[0].max = parseFloat(self.data_1.data_max);
            self.options_chi.yaxis[0].min = parseFloat(self.data_1.data_min);
            self.options_chi.yaxis[1].max = parseFloat(self.data_2.data_max);
            self.options_chi.yaxis[1].min = parseFloat(self.data_2.data_min);
          }
          setTimeout(function(){
            if(self.$i18n.locale == 'tc'){
              self.$refs.realtimeChart.updateOptions(self.options_chi);
            }
            else {
              self.$refs.realtimeChart.updateOptions(self.options);
            }
            self.loading = false;
          },500);
        }
      }
      else if(type="single"){
        // to be coded if needed
      }
    },
    changeOverride(bStatus, eStatus){
      var self = this;
      self.$emit("changeOverride", {bStatus: bStatus, eStatus: eStatus});
    },
    checkOverrided(){
      var self = this;
      apiService
        .checkOverride(
          self.$cookies.get('booking_id'),
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.bStatus=='AVAILABLE' && response.eStatus=="ACTIVE"){
            self.controlAuth=false;
          }
          else if(response.bStatus!="RESERVED" || response.eStatus!="ACTIVE"){
          // either booking or equipment is locked
            if(self.$cookies.get("role")=="player"){
              self.controlAuth=false;
              if(response.eStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "This experiment set is on HOLD by Admin. You are not allowed to control the equipment.");
              else if(response.bStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "Your booking has been SUSPENDED by Admin. You are not allowed to control the equipment.");
              self.changeOverride(response.bStatus, response.eStatus);
            }
            else {
              self.controlAuth=true;
            }
          }
          else {
          // either booking and equipment is active to player
            if(self.$cookies.get("role")=="player")
              self.controlAuth=true;
            else 
              self.controlAuth=false;
          }
        });
    },
    checkGroupSlotOverrided(){
      var self = this;
      apiService
        .checkGroupSlotOverride(
          self.$cookies.get('group_slot_id'),
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {
          if(response.bStatus=='AVAILABLE' && response.eStatus=="ACTIVE"){
            self.controlAuth=false;
          }
          else if(response.bStatus!="RESERVED" || response.eStatus!="ACTIVE"){
          // either booking or equipment is locked
            if(self.$cookies.get("role")=="player"){
              self.controlAuth=false;
              if(response.eStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "This experiment set is on HOLD by Admin. You are not allowed to control the equipment.");
              else if(response.bStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "Your booking has been SUSPENDED by Admin. You are not allowed to control the equipment.");
              self.changeOverride(response.bStatus, response.eStatus);
            }
            else {
              self.controlAuth=true;
            }
          }
          else {
          // either booking and equipment is active to player
            if(self.$cookies.get("role")=="player")
              self.controlAuth=true;
            else 
              self.controlAuth=false;
          }
        });
    },
    clientAction(type, device_id, command){
      var self = this;
      apiService
        .checkOverride(
          self.$cookies.get('booking_id'),
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
        )
        .then((response) => {          
          if(response.bStatus=='AVAILABLE' && response.eStatus=="ACTIVE"){
            self.controlAuth=false;
            self.changeOverride(response.bStatus, response.eStatus);
          }
          else if(response.bStatus!="RESERVED" || response.eStatus!="ACTIVE"){
            // either booking or equipment is locked
            if(self.$cookies.get("role")=="player"){
              self.controlAuth=false;
              if(response.eStatus!="ACTIVE")
                self.$store.commit("showSnackBar", "This experiment set is on HOLD by Admin. You are not allowed to control the equipment.");
              else if(response.bStatus!="ACTIVE"){
                self.$store.commit("showSnackBar", "Your booking has been SUSPENDED by Admin. You are not allowed to control the equipment.");
              }
              self.changeOverride(response.bStatus, response.eStatus);
            }
            else if(self.$cookies.get("role")=="overrider"){
              self.controlAuth=true;
              if (type == "setCommand")
                self.clientSetCommand(device_id, command);
              else if(type == "setChart")
                self.clientRequestChart(device_id, command);
            }
            else {
              self.$store.commit("showSnackBar", "Authorization error. Please re-enter experiment via booking page");
              self.$cookies.remove('booking_id');
              self.$cookies.remove('role');
              self.$cookies.remove('session_token');
              self.$cookies.remove('end_at');
              self.$router.push(
                "/booking/" + self.school_code
              );
            }
          }
          else {
          // either booking and equipment is active to player
            if(self.$cookies.get("role")=="player") {
              apiDDSGeneral
                .getUserInfo(self.$cookies.get("uid"), self.$cookies.get("auth_token"))
                .then((response) => {
                  if(response.status=="success"){
                    self.controlAuth=true;
                    if (type == "setCommand")
                      self.clientSetCommand(device_id, command);
                    else if(type == "setChart")
                      self.clientRequestChart(device_id, command);
                  }
                  else {
                    self.$store.commit("showSnackBar", "Wrong user info, please log in again.");
                  }
                });
            }
            else if(self.$cookies.get("role")=="overrider") {
              self.controlAuth=false;
            }              
            else {
              self.$store.commit("showSnackBar", "Authorization error. Please re-enter experiment via booking page");
              self.$cookies.remove('booking_id');
              self.$cookies.remove('role');
              self.$cookies.remove('session_token');
              self.$cookies.remove('end_at');
              self.$router.push(
                "/booking/" + self.school_code
              );
            }
          }
        });
    },
    clientSetCommand(device_id, command, callback){
      var self = this;
      self.loop_flag = true;
      self.setCommand(device_id, command);
    },
    clientRequestChart(device_id, command){
      var self = this;
      self.loading = true;
      self.setCommand(device_id, command);
      self.inte = setInterval(function () {
        self.getValue(device_id, function () {
          if (self.api.value.chart_at >= self.api.command_set_at) {
            clearInterval(self.inte);
            self.getChart(device_id);
          }
        });
      }, 2000);
    },
    setCommand(device_id, command, callback) {
      var self = this;
      apiService
        .setCommand(
          self.$cookies.get("session_token"),
          self.$cookies.get("role"),
          self.$store.state.current.school_code,
          self.$store.state.current.experiment.toUpperCase(),
          self.$store.state.current.equipment_id,
          device_id,
          command
        )
        .then((response) => {
        });
    },
    downloadZipExperimentData(device_id){
      var self = this;
      apiService
        .downloadZipExperimentData(
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
          device_id,
        )
        .then((response) => {
          if(response.status == "success"){
            window.open(process.env.VUE_APP_BASE_URL + "/api/iot/experiment/" + response.path);
          }
          else {
            alert(response.message);
          }
        });
    },    
    downloadZipGroupExperimentData(device_id){
      var self = this;
      apiService
        .downloadZipGroupExperimentData(
          self.$cookies.get('school_code'),
          self.$cookies.get('experiment'),
          self.$cookies.get('equipment_id'),
          device_id,
          self.$cookies.get('group_slot_id'),
        )
        .then((response) => {
          if(response.status == "success"){
            window.open(process.env.VUE_APP_BASE_URL + "/api/iot/experiment/" + response.path);
          }
          else {
            alert(response.message);
          }
        });
    },
  }
}